import React, { forwardRef, useImperativeHandle, useMemo, useRef, useState } from "react";
import ACModalV2 from "ac-components/ac-modal/ACModalV2";
import './AnyaSummary.less'; // Import the CSS file
import AnyaConversation from "./AnyaConversation";
import { useFeatureFlag } from "contexts/FeatureFlagContext";
import AnyaModalHeader from "./AnyaModalHeader";
import AnyaModalHistoryPanel from "./AnyaModalHistoryPanel";
import useAnyaModalSession from "./useAnyaModalSession";

const AnyaModal = forwardRef(function AnyaModal({ props, showBorder = true }, ref) {
    const thisRef = useRef();
    const messageContainerRef = useRef(null);
    const featureFlags = useFeatureFlag();
    const isAnyaAgentsEnabled = featureFlags.AI_ANYA_AGENT;
    const modalSettings = ACModalV2.useModalSettings();
    const [title, setTitle] = useState(props?.config?.title);
    const widgetType = props?.config?.widgetType === undefined ? "Findings" : props?.config?.widgetType;
    const idFromURL = useMemo(() => {
        const url = new URL(window.location.href);
        const pathName = url.href.split("?")[0];
        const urlParts = pathName.split("/");
        const dashboardId = urlParts[urlParts.length - 1];

        return dashboardId;
    }, []);
    const invocationContext = props?.invocationContext
    const dashboardId = props?.dashboardId || idFromURL;
    const {
        applySessionMetadata,
        agentOptions,
        chatHistory,
        chatId,
        createNewChat,
        deleteConversation,
        fetchChatHistory,
        isNewChat,
        openAgentSession,
        openChatSession,
        searchAgents,
        selectedAgent,
        sessionMode,
        setChatId,
        showHistory,
        startWithEmptyPrompt,
        switchConversation,
        toggleHistory,
    } = useAnyaModalSession({
        props,
        isAnyaAgentsEnabled,
        modalSettings,
        onCreateNewChat: () => {
            setTitle(undefined);
        },
    });

    useImperativeHandle(ref, () => ({
        ...thisRef.current,
    }), []);

    return (
        <div className="anya-prose">
            <AnyaModalHistoryPanel
                chatHistory={chatHistory}
                chatId={chatId}
                onDeleteConversation={deleteConversation}
                onHistorySelected={switchConversation}
                showHistory={showHistory}
            />
            <div className="flex-1 anya-popup-summary" style={!showBorder ? { borderLeft: "none" } : {}}>
                {(props?.showTitle === true || props?.showTitle === undefined) && (
                    <ACModalV2.Title>
                        <AnyaModalHeader
                            chatId={chatId}
                            isAnyaAgentsEnabled={isAnyaAgentsEnabled}
                            onCreateNewChat={createNewChat}
                            onDeleteConversation={deleteConversation}
                            onSelectAgent={openAgentSession}
                            onSelectChat={openChatSession}
                            agentOptions={agentOptions}
                            searchAgents={searchAgents}
                            selectedAgent={selectedAgent}
                            sessionMode={sessionMode}
                            toggleHistory={toggleHistory}
                        />
                    </ACModalV2.Title>
                )}
                <AnyaConversation
                    chatId={chatId}
                    isNewChat={isNewChat}
                    title={title}
                    widgetType={widgetType}
                    dashboardId={dashboardId}
                    fetchChatHistory={fetchChatHistory}
                    setChatId={setChatId}
                    messageContainerRef={messageContainerRef}
                    defaultPromptPrefix={props?.defaultPromptPrefix}
                    showSuggestedQuestions={props?.showSuggestedQuestions}
                    startWithEmptyPrompt={startWithEmptyPrompt}
                    sessionMode={sessionMode}
                    selectedAgent={selectedAgent}
                    onConversationMetadata={applySessionMetadata}
                    invocationContext={invocationContext}
                />
            </div>
        </div>
    );
});

export default AnyaModal;

export const anyaPopupCommonProps = {
    defaultPlacement: "right",
    width: 799,
    mask: true,
    fullHeight: true,
};
